import PropTypes from 'prop-types';
import React from 'react';
import {Row} from 'react-bootstrap';
import {withErrorBoundary} from 'react-error-boundary';
import CgIcon from '@/components/atoms/cg-icon';
import Skeleton from 'react-loading-skeleton';
import AuthorsComponent from '@/components/atoms/authors';
import styles from './authors-list.module.scss';

const AuthorsListComponent = ({authors, onBackArticle}) => {
  return (
    <div className={`${styles.cgList}`}>
      <Row className={`justify-content-center ${styles.cgList__header}`}>
        <CgIcon iconName="BsChevronLeft" className={styles.cgList__back} onClick={()=> onBackArticle(false)} />
        <p className={styles.cgList__title}>Contributors</p>
      </Row>
      {authors?.map((author, index) => <AuthorsComponent key={index} author={author} index={index} showListMobile={() => {}} raiseName={false} /> )}
    </div>
  );
};

AuthorsListComponent.propTypes = {
  authors: PropTypes.any,
  onBackArticle: PropTypes.func
};

const onErrorFallbackComponent = () => <div className={styles.cgList}>
  <Skeleton count={2} />
</div>

export default withErrorBoundary(AuthorsListComponent, {
  FallbackComponent: onErrorFallbackComponent,
  onError: console.debug,
});
